const searchFields = [
    { name: "UserName", type: "text", label: "User Name" },
    { name: "Level", type: "select", showClearButton: true, label: "Level" },
    { name: "DateFrom", type: "datetime", label: "Date From" },
    { name: "DateTo", type: "datetime", label: "Date To" },
    { name: "StatusCode", type: "text", label: "Status Code" },
    { name: "Properties", type: "text", label: "Properties" },
    { name: "Exception", type: "text", label: "Exception" },
    { name: "Message", type: "text", label: "Message", visible: false },
    { name: "DurationSeconds", type: "text", label: "Duration (s)", visible: false },
    { name: "IpAddress", type: "text", label: "IP Address", visible: false },

];

const GROUP_COUNT = 4;
const ApiAuditLogSearchLayout = Array.from({ length: GROUP_COUNT }, (_, i) => ({
    groupId: i + 1,
    label: "",
    fields: []
}));

searchFields.forEach((field, index) => {
    const groupIndex = index % GROUP_COUNT;

    ApiAuditLogSearchLayout[groupIndex].fields.push({
        ...field,
        key: `${field.name}_${index}`,
        tableName: "",
        options: field.options ?? null,
        apiUrl: field.apiUrl ?? null,
        grid: null,
        required: false,
        visible: field.visible ?? true
    });
});

export default ApiAuditLogSearchLayout;
